import { UserRoleType } from '../types/user.enums'
import type { Item } from '@/shared/models/shared.model'
import type { ActivationUser, RegisterUser, UserProfile, UserSetting } from '../models/user.model'
import { ActionType } from '@/modules/action/types/action.enums'

export const DEFAULT_REGISTER_FORM: RegisterUser = {
  firstName: undefined,
  lastName: undefined,
  phone: undefined,
}

export const DEFAULT_PROFILE_FORM: UserProfile = {
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  phone: undefined,
  roleId: UserRoleType.None,
}

export const DEFAULT_ACTIVATION_FORM: ActivationUser = {
  isActivated: false,
  identityProvider: '',
  identityProviderEmail: '',
  activationCode: undefined,
}

export const DEFAULT_USER_SETTING_FORM: UserSetting = {
  languageId: 200,
  viewId: 0,
  outboundZoomLevel: 0,
  outboundMotionBoxPrimaryTextId: 0,
  outboundMotionBoxSecondaryTextId: 0,
  outboundViewDateRange: 0,
  outboundViewDateRangeOffset: 0,
  outboundActionDateRange: 0,
  outboundActionDateRangeOffset: 0,
  outboundAssignedToMe: false,
  outboundActionId: 0,
  outboundActionType: ActionType.None,
  outboundCountryId: 0,
  outboundZipZoneId: 0,
  outboundCarrierId: 0,
  outboundServiceGroupId: 0,
  outboundDimension1Id: 0,
  outboundDimension2Id: 0,
  outboundDimension3Id: 0,
  warehouseZoomLevel: 0,
  warehouseMotionBoxPrimaryTextId: 0,
  warehouseMotionBoxSecondaryTextId: 0,
  warehouseViewDateRange: 0,
  warehouseViewDateRangeOffset: 0,
  warehouseId: 0,
  warehouseDepartureId: 0,
  warehouseDimension1Id: 0,
  warehouseDimension2Id: 0,
  warehouseDimension3Id: 0,
}

export const DEFAULT_MOTION_BOX_OUTBOUND_ZOOM_LEVELS: Item[] = [
  {
    id: 1,
    label: 'Shipment',
  },
  {
    id: 2,
    label: 'Zip zone',
  },
  {
    id: 3,
    label: 'Country',
  },
]

export const DEFAULT_MOTION_BOX_WAREHOUSE_ZOOM_LEVELS: Item[] = [
  {
    id: 1,
    label: 'Order',
  },
  {
    id: 2,
    label: 'Departure',
  },
  {
    id: 3,
    label: 'Warehouse',
  },
]

export const DEFAULT_MOTION_BOX_OUTBOUND_PRIMARY_ITEMS: Item[] = [
  {
    id: 1,
    label: 'Shipment no',
  },
  {
    id: 2,
    label: 'Carrier reference no',
  },
  {
    id: 3,
    label: 'Our reference no',
  },
]

export const DEFAULT_MOTION_BOX_OUTBOUND_SECONDARY_ITEMS: Item[] = [
  {
    id: 1,
    label: 'Shipment no',
  },
  {
    id: 2,
    label: 'Carrier reference no',
  },
  {
    id: 3,
    label: 'Our reference no',
  },
  {
    id: 4,
    label: 'Shipment zip code',
  },
  {
    id: 5,
    label: 'Shipment destination',
  },
  {
    id: 6,
    label: 'Zip code and destination',
  },
  {
    id: 7,
    label: 'Shipment view date',
  },
  {
    id: 8,
    label: 'Carrier name',
  },
]

export const DEFAULT_MOTION_BOX_WAREHOUSE_PRIMARY_ITEMS: Item[] = [
  {
    id: 1,
    label: 'Customer order no',
  },
  {
    id: 2,
    label: 'Warehouse order no',
  },
]

export const DEFAULT_MOTION_BOX_WAREHOUSE_SECONDARY_ITEMS: Item[] = [
  {
    id: 1,
    label: 'Customer order no',
  },
  {
    id: 2,
    label: 'Warehouse order no',
  },
  {
    id: 3,
    label: 'Carrier reference no',
  },
  {
    id: 4,
    label: 'Departure',
  },
  {
    id: 5,
    label: 'Warehouse',
  },
  {
    id: 6,
    label: 'Destination',
  },
  {
    id: 7,
    label: 'Order date',
  },
]
